import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Apple16 = ({
  height = 16,
  width = 16,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="-1 0 16 16" data-test="icon-apple-16" {...props}>
    <path
      d="M10.1266 9.16671C10.1316 8.72821 10.2477 8.29814 10.464 7.91663C10.6802 7.53513 10.9896 7.21463 11.3632 6.98504C11.1254 6.64694 10.8126 6.36837 10.4494 6.17105C10.0861 5.97374 9.68217 5.86303 9.26907 5.84754C8.37657 5.76004 7.51907 6.37254 7.07574 6.37254C6.6324 6.37254 5.90907 5.85921 5.18574 5.87088C4.69957 5.8838 4.22511 6.02287 3.8089 6.27444C3.39268 6.52601 3.049 6.88144 2.81157 7.30588C1.8024 9.05588 2.5549 11.6575 3.54074 13.0809C4.01907 13.775 4.59657 14.5567 5.34907 14.5275C6.10157 14.4984 6.3524 14.0609 7.2274 14.0609C8.1024 14.0609 8.35324 14.5275 9.1174 14.5159C9.88157 14.5042 10.3949 13.8042 10.8674 13.11C11.2092 12.6143 11.4784 12.0721 11.6666 11.5C11.2091 11.3053 10.8191 10.9802 10.5453 10.5652C10.2714 10.1503 10.1258 9.66388 10.1266 9.16671V9.16671Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.93073 3.54339C9.4232 2.96136 9.66818 2.20965 9.61323 1.44922C8.86601 1.51906 8.17446 1.87423 7.6824 2.44089C7.43512 2.72001 7.24713 3.04645 7.12981 3.40042C7.01249 3.75438 6.96829 4.12849 6.9999 4.50005C7.37352 4.49918 7.74195 4.41246 8.07673 4.24658C8.41151 4.08071 8.7037 3.84012 8.93073 3.54339Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
